import React, { useEffect } from 'react'
import { checkOauth } from '../../functions/utils'

const index = ({ triggerNodeCode, triggerNode, redirect, children }) => {
  const [res, setRes] = React.useState({
    needAuthorize: false,
    callback: () => {},
  })
  // const [callback, setCallback] = React.useState<() => void>()
  useEffect(() => {
    if (!triggerNodeCode || !triggerNode) return
    // 获取是否需要授权
    checkOauth(triggerNodeCode, triggerNode, redirect, true).then((res) => {
      // console.log(res)
      // setCallback(res?.callback)
      // setNeedOauth(res?.needAuthorize)
      setRes(res)
    })
  }, [triggerNodeCode, triggerNode])

  return res?.needAuthorize ? (
    <div
      style={{ position: 'relative', minHeight: '100%' }}
      onClick={res.callback}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 9999,
        }}
      ></div>
      {children}
    </div>
  ) : (
    <>{children}</>
  )
}

export default index
